<template>
  <v-dialog
    v-model="dialog"
    persistent
    width="800px"
    scrollable
    @keydown.esc="dialog = false"
  >
    <card>
      <card-content>
        <v-row
          v-for="(title, breakpoint) in breakpoints"
          :key="breakpoint"
          dense
          class="mt-4"
        >
          <v-col cols="12"
            ><h2>{{ title }}</h2></v-col
          >
          <v-col cols="12">
            <v-row dense>
              <v-col cols="6">
                <v-select
                  v-model="rowSettings.dir.values[breakpoint]"
                  label="Направление"
                  dense
                  outlined
                  clearable
                  hide-details
                  :menu-props="{
                    nudgeBottom: 40
                  }"
                  :items="[
                    { value: 'row', text: 'Как обычно' },
                    { value: 'row-reverse', text: 'В обратном порядке' }
                  ]"
                />
              </v-col>
              <v-col cols="6">
                <v-select
                  v-model="rowSettings.wrap.values[breakpoint]"
                  label="Если не влазит"
                  dense
                  outlined
                  clearable
                  hide-details
                  :menu-props="{
                    nudgeBottom: 40
                  }"
                  :items="[
                    { value: 'wrap', text: 'Переносить блоки' },
                    { value: 'nowrap', text: 'Не переносить' }
                  ]"
                />
              </v-col>
            </v-row>

            <v-row dense>
              <v-col cols="6">
                <v-select
                  v-model="rowSettings.justify.values[breakpoint]"
                  label="Выравнивание по горизонтали"
                  dense
                  outlined
                  clearable
                  hide-details
                  :menu-props="{
                    nudgeBottom: 40
                  }"
                  :items="[
                    { value: 'start', text: 'К началу' },
                    { value: 'end', text: 'К концу' },
                    { value: 'center', text: 'К центру' },
                    {
                      value: 'space-between',
                      text: 'Растащить без отступа сбоку'
                    },
                    {
                      value: 'space-around',
                      text: 'Растащить с половинным отступом'
                    }
                  ]"
                />
              </v-col>
              <v-col cols="6">
                <v-select
                  v-model="rowSettings.align.values[breakpoint]"
                  label="Выравнивание по вертикали"
                  dense
                  outlined
                  clearable
                  hide-details
                  :menu-props="{
                    nudgeBottom: 40
                  }"
                  :items="[
                    { value: 'start', text: 'К верху' },
                    { value: 'end', text: 'К низу' },
                    { value: 'center', text: 'К центру' },
                    { value: 'stretch', text: 'Растянуть по высоте' }
                  ]"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </card-content>
      <card-actions>
        <v-spacer />
        <v-btn
          id="form-btn-cancel"
          color="primary"
          depressed
          outlined
          @click="dialog = false"
        >
          {{ "Отменить" }}
        </v-btn>
        <v-btn id="form-btn-save" color="primary" depressed @click="save">
          Сохранить
        </v-btn>
      </card-actions>
    </card>
  </v-dialog>
</template>
<script>
import { cloneDeep } from "lodash";

const breakpointsDict = () => ({
  "": "Phone",
  "-sm": "Tablet",
  "-md": "Laptop",
  "-lg": "Desktop",
  "-xl": "Ultra-wide"
});

const rowSettingsFactory = breakpoints => {
  const sizes = Object.keys(breakpoints).reduce((ind, item) => {
    ind[item] = null;
    return ind;
  }, {});

  return {
    dir: { values: cloneDeep(sizes), prefix: "flex" },
    wrap: { values: cloneDeep(sizes), prefix: "flex" },
    align: { values: cloneDeep(sizes), prefix: "align" },
    justify: { values: cloneDeep(sizes), prefix: "justify" }
  };
};

export default {
  name: "RowSettingsDialog",

  model: {
    prop: "open",
    event: "change"
  },

  props: {
    open: Boolean,
    classes: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      breakpoints: breakpointsDict(),
      rowSettings: rowSettingsFactory(breakpointsDict())
    };
  },

  computed: {
    dialog: {
      get() {
        return this.open;
      },
      set(value) {
        this.$emit("change", value);
      }
    }
  },

  watch: {
    open(newVal) {
      if (newVal) {
        this.reset();
        this.load();
      } else {
        this.reset();
        this.$emit("close");
      }
    }
  },

  methods: {
    async save() {
      const classes = Object.values(this.rowSettings).reduce(
        (classes, item) => {
          const moreClasses = Object.entries(item.values).reduce(
            (innerClasses, entry) => {
              if (entry[1]) {
                innerClasses.push(`${item.prefix}${entry[0]}-${entry[1]}`);
              }
              return innerClasses;
            },
            []
          );
          return [...classes, ...moreClasses];
        },
        []
      );
      this.$emit("apply", classes);
      this.dialog = false;
    },
    async load() {
      this.classes.split(" ").forEach(item => {
        let ident = "";
        let breakpoint = "";
        let data = [];

        if (this.checkIfHasBreakpoint(item)) {
          [ident, breakpoint, ...data] = item.split("-");
          breakpoint = "-" + breakpoint;
        } else {
          [ident, ...data] = item.split("-");
          breakpoint = "";
        }

        if (["", "row", "aunfrow"].includes(ident)) {
          return;
        } else if (ident == "flex") {
          if (["wrap", "nowrap"].includes(data[0])) {
            this.rowSettings.wrap.values[breakpoint] = data.join("-");
          } else {
            this.rowSettings.dir.values[breakpoint] = data.join("-");
          }
        } else {
          this.rowSettings[ident].values[breakpoint] = data.join("-");
        }
      });
    },
    reset() {
      this.$set(this, "rowSettings", rowSettingsFactory(this.breakpoints));
    },
    checkIfHasBreakpoint(str) {
      return Object.keys(breakpointsDict()).some(
        key => str.includes(key) && key !== ""
      );
    }
  }
};
</script>
